// Sign in with Apple — wraps Apple's appleid.auth JS SDK.
//
// Setup required in Apple Developer portal (Services ID, NOT App ID):
//   • Identifier: app.velkra.dist (must match APPLE_SIWA_CLIENT_ID on backend
//     + VITE_APPLE_SIWA_CLIENT_ID on Vercel)
//   • Sign In with Apple: enabled + configured with a Primary App ID
//   • Domains: dist.velkra.app (must be verified — see
//     public/.well-known/README.md for the domain-association file)
//   • Return URLs: register BOTH of these so either env var value works:
//       - https://dist.velkra.app/login
//       - https://dist.velkra.app/auth/apple/callback
//     (vercel.json rewrites /auth/apple/callback → /login, so the React
//     route only needs to exist at /login.)
//
// Pop-up flow (usePopup: true) returns id_token + (first time only)
// user.name + user.email via postMessage. The redirectURI is still
// VALIDATED by Apple against the registered Return URLs even though
// no actual HTTP redirect happens.

const SIWA_CLIENT_ID = import.meta.env.VITE_APPLE_SIWA_CLIENT_ID || 'app.velkra.dist';
const SIWA_REDIRECT_URI = import.meta.env.VITE_APPLE_SIWA_REDIRECT
  || (typeof window !== 'undefined' ? window.location.origin + '/login' : '');

let _initialized = false;

export function initApple() {
  if (_initialized) return;
  if (typeof window === 'undefined' || !window.AppleID) return;
  window.AppleID.auth.init({
    clientId: SIWA_CLIENT_ID,
    scope: 'name email',
    redirectURI: SIWA_REDIRECT_URI,
    state: cryptoRandom(16),
    usePopup: true
  });
  _initialized = true;
}

export async function signInWithApple() {
  // Wait for the SDK to be present (it loads async).
  for (let i = 0; i < 50 && (!window.AppleID || !window.AppleID.auth); i++) {
    await new Promise(r => setTimeout(r, 100));
  }
  if (!window.AppleID || !window.AppleID.auth) {
    throw new Error('Apple Sign In SDK failed to load. Disable content blockers and retry.');
  }
  initApple();
  const data = await window.AppleID.auth.signIn();
  // data.authorization.id_token + data.user (first time only)
  return {
    idToken: data.authorization.id_token,
    user: data.user
  };
}

function cryptoRandom(n) {
  const arr = new Uint8Array(n);
  crypto.getRandomValues(arr);
  return Array.from(arr).map(b => b.toString(16).padStart(2, '0')).join('');
}
